function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : ((e = e || self).__vee_validate_locale__pl = e.__vee_validate_locale__pl || {}, e.__vee_validate_locale__pl.js = n());
}(this, function () {
  "use strict";

  var e;

  var r = function (e, n, i, o) {
    return 1 === (o = Math.abs(o)) ? e : 2 <= o % 10 && o % 10 <= 4 && (o % 100 < 10 || 20 <= o % 100) ? n : i;
  }.bind(null, "znak", "znaki", "znaków"),
      n = {
    name: "pl",
    messages: {
      _default: function _default(e) {
        return "Pole " + e + " jest nieprawidłowe";
      },
      after: function after(e, n) {
        return "Pole " + e + " musi być po polu " + n[0];
      },
      alpha: function alpha(e) {
        return "Pole " + e + " może zawierać tylko litery";
      },
      alpha_dash: function alpha_dash(e) {
        return "Pole " + e + " może zawierać litery, cyfry oraz myślnik lub podkreślnik";
      },
      alpha_num: function alpha_num(e) {
        return "Pole " + e + " może zawierać tylko litery i cyfry";
      },
      alpha_spaces: function alpha_spaces(e) {
        return "Pole " + e + " może zawierać tylko litery oraz spacje";
      },
      before: function before(e, n) {
        return "Pole " + e + " musi być przed " + n[0];
      },
      between: function between(e, n) {
        return "Pole " + e + " musi być pomiędzy " + n[0] + " oraz " + n[1];
      },
      confirmed: function confirmed(e, n) {
        return "Pole " + e + " nie zgadza się z polem potwierdzającym " + n[0];
      },
      credit_card: function credit_card(e) {
        return "Pole " + e + " musi być poprawnym numerem karty kredytowej";
      },
      date_between: function date_between(e, n) {
        return "Pole " + e + " musi zawierać się między " + n[0] + " a " + n[1];
      },
      date_format: function date_format(e, n) {
        return "Pole " + e + " musi pasować do formatu " + n[0];
      },
      decimal: function decimal(e, n) {
        void 0 === n && (n = []);
        var i = n[0];
        return void 0 === i && (i = "*"), "Pole " + e + " musi być liczbą i może zawierać" + (i && "*" !== i ? " " + i : "") + " miejsca po przecinku";
      },
      digits: function digits(e, n) {
        return "Pole " + e + " musi być liczbą i dokładnie " + n[0] + " cyfr";
      },
      dimensions: function dimensions(e, n) {
        return "Obraz " + e + " musi być szeroki na " + n[0] + " pikseli i wysoki na " + n[1] + " pikseli";
      },
      email: function email(e) {
        return "Pole " + e + " musi być poprawnym adresem email";
      },
      excluded: function excluded(e) {
        return "Pole " + e + " musi być poprawną wartością";
      },
      ext: function ext(e) {
        return "Plik " + e + " musi być poprawnym plikiem";
      },
      image: function image(e) {
        return "Pole " + e + " musi być obrazem";
      },
      included: function included(e) {
        return "Pole " + e + " musi być poprawną wartością";
      },
      integer: function integer(e) {
        return "Pole " + e + " musi być liczbą całkowitą";
      },
      ip: function ip(e) {
        return "Pole " + e + " musi być poprawnym adresem IP";
      },
      length: function length(e, n) {
        var i = n[0],
            o = n[1];
        return o ? "Pole " + e + " musi mieć długość od " + i + " do " + o + " znaków" : "Pole " + e + " musi mieć długość " + i + " " + r(i);
      },
      max: function max(e, n) {
        var i = n[0];
        return "Pole " + e + " nie może być dłuższe niż " + i + " " + r(i);
      },
      max_value: function max_value(e, n) {
        return "Pole " + e + " musi mieć maksymalną wartość " + n[0];
      },
      mimes: function mimes(e) {
        return "Plik " + e + " musi posiadać poprawne rozszerzenie";
      },
      min: function min(e, n) {
        var i = n[0];
        return "Pole " + e + " musi być długie na co najmniej " + i + " " + r(i);
      },
      min_value: function min_value(e, n) {
        return "Pole " + e + " musi mieć minimalną wartość " + n[0];
      },
      numeric: function numeric(e) {
        return "Pole " + e + " może zawierać tylko cyfry";
      },
      regex: function regex(e) {
        return "Format pola " + e + " jest nieodpowiedni";
      },
      required: function required(e) {
        return "Pole " + e + " jest wymagane";
      },
      size: function size(e, n) {
        return "Plik " + e + " musi być mniejszy niż " + function (e) {
          var n = 1024,
              i = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
          return 1 * (e / Math.pow(n, i)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][i];
        }(n[0]);
      },
      url: function url(e) {
        return "Pole " + e + " nie jest poprawnym URL";
      }
    },
    attributes: {}
  };

  return "undefined" != typeof VeeValidate && VeeValidate.Validator.localize(((e = {})[n.name] = n, e)), n;
});